import dayjs from "dayjs";
import { PeriodRange } from "./PeriodRange";
import { DeltaCalculator } from "./Delta";
import { Period } from "./Period";
import { MetricCode } from "./Metrics";

export enum MetricType {
    CURRENCY = "Currency",
    STRING = "String",
    PERCENTAGE = "Percentage",
    RATIO = "Ratio",
    MULTIPLE = "Multiple",
    DATE = "Date",
    BOOLEAN = "Boolean",
    INTEGER = "Integer",
    PERIOD = "Period",
}

export enum PeriodResolution {
    MONTHLY = "monthly",
    QUARTERLY = "quarterly",
    YEARLY = "yearly",
}

export enum MetricSource {
    FINANCE_API = "finance",
    FINANCE_LAB = "financeLab",
}

export type PeriodWindow = {
    resolution: PeriodResolution;
    windowSize: number;
};

export type PeriodOption = {
    id: string;
    label: string;
    resolution: PeriodResolution;
    getPeriodRange: (
        asOfDate: dayjs.Dayjs,
        metricPeriodRange: PeriodRange | null,
    ) => PeriodRange | null;
    isDisabled: (metricPeriodRange: PeriodRange | null) => boolean;
    threshold: number | null;
};

export interface PeriodCategory {
    id: string;
    label: string;
    options: PeriodOption[];
}

export enum DeltaType {
    PERIOD_OVER_PERIOD = "PERIOD_OVER_PERIOD",
    CUMULATIVE = "CUMULATIVE",
}

export type WithDeltaCalculator<T> = T & {
    deltaCalculator: DeltaCalculator;
};

// Parsed Lineage Types
export type Value = {
    value: number;
    ref: string;
    meta?: {
        period: string;
        accountId: string;
        dataAssetId: string;
        location: string;
    };
};

export type ParsedMetric = {
    period: Period;
    result: number;
    formula: string;
    values: Value[];
};

export type MetricConfig = {
    code: MetricCode;
    label: string;
    type: MetricType;
    source: MetricSource;
};
